var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Typing effect "),_c('span',{staticClass:"typed-text"},[_vm._v(_vm._s(_vm.typeValue))]),_c('span',{staticClass:"cursor",class:{'typing': _vm.typeStatus}},[_c('pre')])])])}
var staticRenderFns = []

export { render, staticRenderFns }